import { render } from "./SystemRolesGrid.vue?vue&type=template&id=7baae135&scoped=true&ts=true"
import script from "./SystemRolesGrid.vue?vue&type=script&lang=ts"
export * from "./SystemRolesGrid.vue?vue&type=script&lang=ts"

import "./SystemRolesGrid.vue?vue&type=style&index=0&id=7baae135&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7baae135"]])

export default __exports__